import React, { useEffect, useState } from 'react';
import AdvancedOptionCard from 'scenes/V3/CreateAccountScene/OptionCards/AdvancedOptionCard';
import './UserPersona.scss';
import { trackMixpanelPageView } from '@helpers/post';
import { changeProfileField } from 'redux/ducks/Post/Profile';
import { clearV2Form } from 'redux/ducks/Post/actions';
import { update } from 'redux/ducks/User';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

const PERSONA_OPTIONS = [
  {
    title: 'One-Time / Per Diem',
    body: 'Coverage for a single event or short-term job.',
    value: 'single',
  },
  {
    title: 'Recurring',
    body: 'Athletic trainers needed throughout the year, but not full time.',
    value: 'recurring',
  },
  {
    title: 'Long-Term Placement',
    body: 'Hiring for a month or more of consistent coverage.',
    value: 'contract',
    href: 'https://www.go4.io/contract-services-consultation-form-platform/',
  },
];

const UserPersona = ({ update, user, onChangeProfile, history }) => {
  const [selectedPersona, setSelectedPersona] = useState(user.userPersona?.toLowerCase());
  const [href, setHref] = useState(null);
  const buttonDisabled = !selectedPersona;

  useEffect(() => {
    trackMixpanelPageView('/v2/create-event/persona');
    document.body.classList.add('hide-chat');

    return () => {
      document.body.classList.remove('hide-chat');
    };
  }, []);

  const onSelect = (type, href) => {
    setSelectedPersona(type);
    setHref(href);
  };

  const onContinue = () => {
    if (!selectedPersona) return;

    if (selectedPersona !== 'null')
      update({
        ...user,
        userPersona: selectedPersona.replace(/^./, selectedPersona[0].toUpperCase()),
      });

    if (selectedPersona === 'contract') {
      onChangeProfile({
        name: 'eventType',
        value: selectedPersona,
      });
      trackMixpanelPageView('LongTermForm');
      window.open(href, '_blank');
    } else {
      onChangeProfile({
        name: 'eventType',
        value: 'per-diem',
      });
      history.push('/v2/create-event/setting');
    }
  };

  return (
    <div className="user-persona">
      <main>
        <header>
          <div className="screen-title gotham-bold-font">Great, let's find you an athletic trainer!</div>
          <div className="screen-subtitle">How do you plan to use Go4?</div>
        </header>
        <div className="persona-options">
          {PERSONA_OPTIONS.map(({ title, body, value, href }) => (
            <AdvancedOptionCard
              key={value}
              className="persona-option"
              title={title}
              body={body}
              onClick={() => onSelect(value, href)}
              selected={selectedPersona === value}
            />
          ))}
        </div>
      </main>
      <div className="navigation-buttons">
        <Button onClick={onContinue} className="continue-button" disabled={buttonDisabled}>
          <div>Continue &#8594;</div>
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  profile: state.post.profile,
  authenticated: state.session.authenticated,
  user: state.session.currentUser,
});

const mapDispatchToProps = dispatch => ({
  onChangeProfile: ({ name, value }) => dispatch(changeProfileField({ name, value })),
  clearV2Form: () => dispatch(clearV2Form()),
  update: user => dispatch(update(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserPersona);
